export const newLondon800 = [ 
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/58826a101eaf0ed7e8f1a0524160cab9461550164d1fa9fec791d540.jpg",
    type: "Room",
    available: "From 30 November",
    title: "Cosy room to rent in Greenford, London",
    rent: "£350",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/302159",
    id: "london1"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in spacious 9-bedroom house in Cricklewood",
    rent: "£475",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/411811",
    id: "london2"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/675727045429be00d2230dcaeef8982c549d0fca1b99d164e667a4b3.jpg",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in spacious 9-bedroom house in Cricklewood",
    rent: "£499",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/411808",
    id: "london3"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/359c08a9f8c7c82bd0d14fa550281c38c7abad50dffada92624e1931.jpg",
    type: "Room",
    available: "From 26 June",
    title: "Great room in 2-bedroom flat in Southwark, London",
    rent: "£500",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/113333",
    id: "london4"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/850b6d481499a6be33714196b300904bc2060292127b09bc13af32d0.jpg",
    type: "Room",
    available: "From 1 January 2023",
    title: "Light room in 3-bedroom apartment in Southwark, London",
    rent: "£500",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/258582",
    id: "london5"
  },
  {
    verified: "CHECKED",
    image:
      "https://d1052pu3rm1xk9.cloudfront.net/pt_640_480/6dec3fb48df1e28c9889e1d40885ea769f201b579f59a8bc963ab7b5.jpg",
    type: "Room",
    available: "From 6 January 2023",
    title: "Room to rent in comfy 5-bedroom house, east London",
    rent: "£500",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/347320",
    id: "london6"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Room to rent in 5-bedroom house in Hammersmith, London",
    rent: "£530",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/317870",
    id: "london7"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 4 October",
    title: "Bedroom for rent in 5-Bedroom Apartment in Forest Gate",
    rent: "£540",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/106976",
    id: "london8"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 15 August",
    title: "Room for rent in 4-bedroom house in Greenwich, London",
    rent: "£545",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/330296",
    id: "london9"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Cosy room to rent in 4-bedroom house, Redbridge, London",
    rent: "£550",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/314650",
    id: "london10"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 11 October",
    title: "3-bedroom apartment for rent in South Harrow, London",
    rent: "£550",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/601258",
    id: "london11"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 January 2023",
    title: "Room for rent in a residence in Croydon, London",
    rent: "£550",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/363206",
    id: "london12"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 9 January 2023",
    title: "Rooms to rent in 5-bedroom houseshare in Poplar, London",
    rent: "£550",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/281544",
    id: "london13"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Room to rent in 5-bedroom house, relaxed Hammersmith, London",
    rent: "£560",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/317869",
    id: "london14"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Bright room to rent in 6-bedroom house, Redbridge London",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/315289",
    id: "london15"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 11 July",
    title: "Room in shared apartment in High Wycombe",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/376116",
    id: "london16"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 11 July",
    title: "Room in shared apartment in High Wycombe",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/376112",
    id: "london17"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 12 September",
    title: "Room in shared apartment in High Wycombe",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/376113",
    id: "london18"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 3 October",
    title: "Room in shared apartment in High Wycombe",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/376111",
    id: "london19"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 October",
    title: "Room in shared apartment in High Wycombe",
    rent: "£575",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/376119",
    id: "london20"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Furnished room in 5-bedroom flat in Putney, London",
    rent: "£583",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/103775",
    id: "london21"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Bright room to rent in 4-bedroom flat in Bethnal Green",
    rent: "£585",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/303736",
    id: "london22"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Bright room for rent in Bethnal Green, London",
    rent: "£595",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/339537",
    id: "london23"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Rooms to rent in spacious 5-bedroom flat in Shoreditch",
    rent: "£595",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/325018",
    id: "london24"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in 6-Bedroom House in Redbridge, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/314614",
    id: "london25"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Large room in 2-bedroom flat in Newham, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/111183",
    id: "london26"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 18 August",
    title: "Room to rent in comfy 5-bedroom house, east London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/385877",
    id: "london27"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 31 August",
    title: "Rooms for rent in 2-bedroom house in Bromley, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/149882",
    id: "london28"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 11 September",
    title: "Room to rent in 4-bedroom houseshare in Brockley, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/379387",
    id: "london29"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 6 October",
    title: "Room for rent in 5-bedroom house in Uxbridge, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/641578",
    id: "london30"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Stylish room to rent in 4-bedroom flatshare in Plaistow",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/379482",
    id: "london31"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 January 2023",
    title: "Rooms to rent in 4-bedroom flat in Royal Docks, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/383993",
    id: "london32"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 January 2023",
    title: "Single room for rent, 3-bedroom flat, Tottenham, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/384172",
    id: "london33"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Room for rent in 4-bedroom flat in Hammersmith & Fulham",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/319914",
    id: "london34"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Room in 6-bedroom apartment in Lilburne Court, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/271996",
    id: "london35"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Large room in flat in Earls Court, London",
    rent: "£600",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/121805",
    id: "london36"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Quiet room to rent in 5-bedroom house, Hammersmith, London",
    rent: "£620",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/317871",
    id: "london37"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 December",
    title: "Lovely room in 4-bedroom flat in Bethnal Green, London",
    rent: "£625",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/131942",
    id: "london38"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Room for rent in 5-room apartment in Tower Hamlets, London",
    rent: "£625",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/513775",
    id: "london39"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Cosy room to rent in 4-bedroom flatshare in Putney, London",
    rent: "£630",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/200273",
    id: "london40"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Rooms for rent in 5-bedroom house in Tower Hamlets, London",
    rent: "£635",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/396274",
    id: "london41"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Equipped room in shared flat in Putney, London",
    rent: "£648",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/101277",
    id: "london42"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 4 May",
    title: "Room for rent in spacious 9-bedroom house in Cricklewood",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/411816",
    id: "london43"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 9 May",
    title: "Room for rent in 5-bedroom house in Uxbridge, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/639200",
    id: "london44"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 19 May",
    title: "Room for rent in 2-bedroom house in Southall, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/635407",
    id: "london45"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 11 June",
    title: "Room for rent in a flatshare in Brixton, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/603959",
    id: "london46"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in spacious 9-bedroom house in Cricklewood",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/411809",
    id: "london47"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 July",
    title: "Room for rent in spacious 9-bedroom house in Cricklewood",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/411810",
    id: "london48"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 16 July",
    title: "Furnished room to rent in 3-bedroom flat in Southall, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/305790",
    id: "london49"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 19 August",
    title: "Ensuite room to rent in comfy 5-bedroom house, east London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/313507",
    id: "london50"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 21 August",
    title: "Cosy room to rent in 2-bedroom flat in Lambeth, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/378381",
    id: "london51"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 November",
    title: "Double bedroom for rent in 3-bed apartment, Mitcham, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/202243",
    id: "london52"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Cosy room in 5-bedroom houseshare in Greenwich, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/348611",
    id: "london53"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Cosy room in 4-bedroom flatshare in Tower Hamlets, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/255675",
    id: "london54"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Rooms to rent in 5-bedroom flatshare Tower Hamlets, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/247959",
    id: "london55"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Cosy room in 4-bedroom flat in Lewisham, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/234005",
    id: "london56"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 1 January 2023",
    title: "Spacious room in 3-bedroom apartment in South Ealing, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/224153",
    id: "london57"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 January 2023",
    title: "Sunny room to rent in Harringay, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/271786",
    id: "london58"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 2 January 2023",
    title: "Room in a shared house with garden in North Acton",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/460633",
    id: "london59"
  },
  {
    verified: "CHECKED",
    type: "Room",
    available: "From 7 January 2023",
    title: "Room in a 4-Bedroom Apartment for rent in Wandsworth, London",
    rent: "£650",
    permonth: "/month",
    link:
      "https://spotahome.sjv.io/c/2913702/870243/12133?url=https://www.spotahome.com/london/for-rent:rooms/572497",
    id: "london60"
  },
];
